import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import { classesInjection } from '../utils/transitions'
import { html } from '../utils/environment'

// eslint-disable-next-line import/prefer-default-export
export class Fade extends Highway.Transition {
  in({ from, to, done }) {
    const wrapper = document.querySelector('.c-preloader')
    const layer = document.querySelector('.c-preloader__layer')
    const logo = document.querySelector('.c-preloader__logo')

    const tl = gsap.timeline()

    window.scrollTo(0, 0)

    classesInjection(to)
    html.classList.remove('has-menu-open')

    from.remove()

    tl.fromTo(
      to,
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        duration: 0.35,
        onComplete: done,
      },
    ).to(layer, {
      duration: 1.2,
      ease: 'expo.inOut',
      clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
      transformOrigin: 'bottom',
    }).to(logo, {
      duration: 0.6,
      autoAlpha: 0,
    }, '-=1.1').set(wrapper, { display: 'none' })

    // console.log('enter done')

    return this
  }

  out({ from, done }) {
    const wrapper = document.querySelector('.c-preloader')
    const layer = document.querySelector('.c-preloader__layer')
    const logo = document.querySelector('.c-preloader__logo')

    const tl = gsap.timeline()

    tl.set(wrapper, {
      display: 'block',
    }).fromTo(
      layer,
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
        transformOrigin: 'top',
      },
      {
        duration: 1.2,
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        ease: 'expo.inOut',
      },
    ).to(logo, {
      duration: 0.6,
      autoAlpha: 1,
    }, '-=0.6')
      .fromTo(
        from,
        { autoAlpha: 1 },
        {
          autoAlpha: 0,
          duration: 0.35,
          onComplete: done,
        },
      )

    // console.log('exit done')

    return this
  }
}
